export const environment = {
    production: false,
    env_type:'dev',
    api_gw:'https://dev-ccmapi.communicationgenetics.com/v1',
    authority:'https://ccm-security.communicationgenetics.com/realms/CCM_SaaS_DEV',
    client_id:'CCM_SaaS_DEV',
    client_secret:'w8xnUkwrC8qlUp247Ugfg3vHjOcpQ0NF',
    websocketURL: 'wss://7ztqo2mw6d.execute-api.af-south-1.amazonaws.com/dev',
    environmentName: " - DEV"
};